import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const HeartFilled: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = '#000',
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M8.65065 3.24684C9.8238 3.62302 10.9294 4.3959 12 5.20947C13.0706 4.3959 14.1762 3.62303 15.3493 3.24685C16.7748 2.78975 18.2565 2.92602 19.8586 4.00651C19.8762 4.01838 19.8933 4.03099 19.9099 4.04429C20.8918 4.83435 21.8431 6.25844 21.9825 8.16452C22.1228 10.0834 21.4352 12.3976 19.31 14.9629C17.511 17.1344 14.9603 19.5719 12.3566 20.9118C12.3452 20.9177 12.3338 20.9234 12.3222 20.9288C12.2212 20.9757 12.1146 20.9988 12.0093 20.9999C11.889 21.0015 11.7667 20.9747 11.6525 20.9164L11.6483 20.9143C9.04293 19.575 6.49008 17.1358 4.69004 14.963C2.56481 12.3976 1.87717 10.0834 2.01748 8.16453C2.15685 6.25845 3.10816 4.83436 4.09015 4.0443C4.10668 4.03099 4.12378 4.01839 4.14138 4.00651C5.74346 2.92603 7.22517 2.78975 8.65065 3.24684Z"
        fill={color}
      />
    </svg>
  );
};

export default HeartFilled;
